import { FormBuilder } from '@fareye/form-builder'
import { Modal, toast } from '@fareye/ui'
import React, { useEffect, useState } from 'react'
import { DEFAULT_POI_FORM_RENDERING, POI_CONFIG, POI_FORM_RENDERING, HEADER_INFLECTION } from '../../../config/constants'
import { isEmpty } from 'lodash'
import { cancelToken, post, put } from '@fareye/utils'

export default function PoiModal({ selectedPoi, setSelectedPoi }: any) {
  const [submitValue, setSubmitValues] = useState<any>({})
  const {defaultPoiConfig}=POI_CONFIG
  const source=cancelToken().source()
  const handleToggleModal = (toggle: boolean) => {
    setSelectedPoi((selectedPoi: any) => {
      return {
        ...selectedPoi,
        openModal: toggle
      }
    })
  }

  const handleUpdatePoiConfig= async(config: any,defaultPoiId:number) => {
    try {
        let url= `${defaultPoiConfig}/${defaultPoiId}`
        const {data}=await put(url,config,source.token,HEADER_INFLECTION)
        toast.success('Poi config updated successfully')
        handleToggleModal(false)
    } catch (error) {
        toast.error('Something went wrong')

    }
  }
  const handleAddPoiConfig= async(config: any) => {
    try {
        
        let url= `${defaultPoiConfig}`
        const {data}=await post(url,config,source.token,HEADER_INFLECTION)
        toast.success('Poi config added successfully')
        handleToggleModal(false)
    } catch (error) {
        toast.error('Something went wrong')
    }
}

  useEffect(() => {
    if (!isEmpty(submitValue)) {
        try {
          const {
            id,
            userId,
            identifier,
            radius,
            Type,
            poiType,
            isActive,
            geocodingOption,
            poisFlowCode,
            minDwellTime,
            maxWaitIfExited,
            maxWaitIfInside
          } = submitValue.values
          let payload = {
            defaultPoiConfig: {
              userId,
              identifier:identifier.value,
              radius,
              poiType:poiType.value,
              _type:Type.value,
              isActive,
              geocodingOption:geocodingOption.value,
              poisFlowCode,
              minDwellTime,
              maxWaitIfExited,
              maxWaitIfInside
            }
          }
        if(selectedPoi.action==="edit"){
            handleUpdatePoiConfig(payload,id)
        }else{
            handleAddPoiConfig(payload)
        }
      } catch (error) {
        toast.error("Something went wrong...")
      }
    }
  }, [submitValue])

  return (
    <Modal
      toggleModal={selectedPoi.openModal}
      setToggleModal={handleToggleModal}
    >
      <FormBuilder
        config={DEFAULT_POI_FORM_RENDERING as any}
        formDefaultValue={selectedPoi.data}
        setSubmitValues={setSubmitValues}
        baseUrl=""
      />
    </Modal>
  )
}
